import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Instagram, Youtube, Mail, Linkedin } from "lucide-react";
import logoAtaric from "../../../../assets/logo-ataric.png";
import analytics from "../../../../libs/analytics";

const Footer = () => {
  const scrollToSection = (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    e.stopPropagation();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-16 bg-card border-t border-border">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-2xl md:text-3xl font-bold mb-4">
            Pronto para{" "}
            <span className="text-gradient">destravar seu inglês?</span>
          </h2>
          <p className="text-muted-foreground mb-6">
            Comece hoje e fale inglês com confiança em poucos dias.
          </p>
          <Button type="button" variant="cta" size="xl" onClick={(e) => { analytics.landingCtaClicked('footer'); scrollToSection(e, 'planos'); }}>
            👉 Quero começar agora
          </Button>
        </motion.div>

        <div className="section-divider mb-12" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img src={logoAtaric} alt="Ataric" className="h-24 w-auto" />
          </div>

          {/* Links */}
          <nav className="flex flex-wrap items-center justify-center gap-6">
            <button type="button" onClick={(e) => scrollToSection(e, 'beneficios')} className="text-muted-foreground hover:text-foreground transition-colors text-sm cursor-pointer">
              Benefícios
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'depoimentos')} className="text-muted-foreground hover:text-foreground transition-colors text-sm cursor-pointer">
              Depoimentos
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'planos')} className="text-muted-foreground hover:text-foreground transition-colors text-sm cursor-pointer">
              Planos
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'faq')} className="text-muted-foreground hover:text-foreground transition-colors text-sm cursor-pointer">
              FAQ
            </button>
            <a href="/blog" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
              Blog
            </a>
            <a href="https://ataric.com.br/termos" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
              Termos de Uso
            </a>
            <a href="https://ataric.com.br/privacidade" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
              Privacidade
            </a>
          </nav>

          {/* Social */}
          <div className="flex items-center gap-4">
            <a 
              href="https://instagram.com/ataricapp" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-secondary hover:bg-primary/20 flex items-center justify-center transition-colors"
            >
              <Instagram className="w-5 h-5 text-muted-foreground" />
            </a>
            <a 
              href="https://www.linkedin.com/company/ataric-app" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-secondary hover:bg-primary/20 flex items-center justify-center transition-colors"
            >
              <Linkedin className="w-5 h-5 text-muted-foreground" />
            </a>
            <a
              href="https://youtube.com/@ataricapp" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-secondary hover:bg-primary/20 flex items-center justify-center transition-colors"
            >
              <Youtube className="w-5 h-5 text-muted-foreground" />
            </a>
            <a 
              href="mailto:contato@ataric.com.br"
              className="w-10 h-10 rounded-full bg-secondary hover:bg-primary/20 flex items-center justify-center transition-colors"
            >
              <Mail className="w-5 h-5 text-muted-foreground" />
            </a>
          </div>
        </div>

        <div className="text-center mt-12 text-sm text-muted-foreground">
          <p>© 2026 Ataric. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
